import axiosIns from '@/api/axios'

export const EXPORT_COMMON_REPORT = (payload = {}) => {
  const cleanPayload = Object.fromEntries(
    Object.entries(payload).filter(
      ([, value]) => value !== null && value !== undefined && value !== ''
    )
  )

  return axiosIns.post('/common/reports', cleanPayload, {
    responseType: 'blob'
  })
}

export const REPORT_TYPE_OPTIONS = [
  { label: 'TNA Report', value: 'tna' },
  { label: 'Training Report', value: 'training' },
  { label: 'Approval Report', value: 'approval' },
  { label: 'IDP Report', value: 'idp' },
  { label: 'Project Report', value: 'project' },
  { label: 'Coaching / Mentoring Report', value: 'coaching' },
  { label: 'Assessment Report', value: 'assessment' },
  { label: 'Certificate Database', value: 'certificate' }
]

export const REPORT_TYPE_LABELS = Object.fromEntries(
  REPORT_TYPE_OPTIONS.map(({ value, label }) => [value, label])
)

export const TNA_REPORT_COLUMNS = [
  'No',
  'NIK',
  'Employee Name',
  'Company',
  'Division',
  'Department',
  'Position',
  'Training Name',
  'Estimated Course Price (IDR)',
  'Estimated Accomodation Price (IDR)',
  'Estimated Ticket Price (IDR)',
  'Total Estimated Price (IDR)',
  'Training Type (INT/EXT)',
  'Category (Mandatory/Gap)',
  'TNA Year',
  'Submission Date',
  'Status (Submitted/Approved/On Approval)',
  'Manager Name',
  'Manager Approval Date',
  'HR Name',
  'HR Approval Date'
]

export const IDP_REPORT_COLUMNS = [
  'No',
  'NIK',
  'Employee Name',
  'Company',
  'Department',
  'Position',
  'Course Name',
  'Provider',
  'Training Start Date',
  'Training End Date',
  'Location',
  'License / Certificate Number',
  'Klasifikasi Training (Mandatory, Technical, Soft)',
  'Jenis Training (Certification, Semi Certification, Training)',
  'STEM (Science, Technology, etc.)',
  'Learning Days',
  'Learning Hours',
  'Training Year',
  'Currency',
  'Course Price',
  'Accommodation Price',
  'Ticket Price',
  'INT/EXT',
  'Course Category (PWD, PKK, dst)',
  'Category (Mandatory/Gap)',
  'Competency Name',
  'Competency Proficiency',
  'Batch Name',
  'Registration Type (TNA/Assignment)',
  'Training Period (Year)',
  'Status (Completed/Ongoing/Waiting Approval)'
]
export const COACHING_REPORT_COLUMNS = [
  'No',
  'NIK',
  'Employee Name',
  'Coach/Mentor Name',
  'Coach/ Mentor Approval Date',
  'Coaching Topic',
  'Description',
  'Start Date',
  'End Date',
  'Status (Completed / Ongoing)',
  'Year'
]

export const APPROVAL_REPORT_COLUMNS = [
  'No',
  'NIK',
  'Employee Name',
  'Scope (BIB/Mitra)',
  'Course Name',
  'Enrollment Type (Enrollment/ Unenrollment/ Assignment)',
  'Enrollment Date',
  'Course Start Date',
  'Course End Date',
  'Approval Status (Approved/Waiting Approval/Rejected)',
  'Course Status (Completed/On Going/Upcoming)',
  'Manager Name',
  'Manager Approval Date',
  'HR Name',
  'HR Approval Date',
  'KTT Approval Date',
  'Year'
]

export const ASSESSMENT_REPORT_COLUMNS = [
  'No',
  'NIK',
  'Employee Name',
  'Company',
  'Department',
  'Position',
  'Competency Name',
  'Required Proficiency',
  'Actual Proficiency',
  'Gap',
  'Assessment Year',
  'Assessment Date',
  'Assessor Name',
  'Previous Year Score',
  'Current Year Score'
]

export const ASSESSMENT_REPORT_EMPTY_COLUMNS = [
  'Assessor Name',
  'Previous Year Score',
  'Current Year Score'
]

export const CERTIFICATE_REPORT_COLUMNS = [
  'No',
  'Nama',
  'Jabatan',
  'Departemen',
  'Division',
  'Judul Sertifikat',
  'Jenis Sertifikasi',
  'No Sertifikat',
  'No Registrasi',
  'Tanggal Terbit Sertifikat',
  'Masa Berlaku (Bulan)',
  'Tanggal Exp Sertifikat',
  'Perpanjangan/Baru',
  'Keterangan'
]

export const REPORT_COLUMN_MAP = {
  tna: TNA_REPORT_COLUMNS,
  idp: IDP_REPORT_COLUMNS,
  coaching: COACHING_REPORT_COLUMNS,
  approval: APPROVAL_REPORT_COLUMNS,
  assessment: ASSESSMENT_REPORT_COLUMNS,
  certificate: CERTIFICATE_REPORT_COLUMNS
}

export const getReportFilename = (type, startDate, endDate) => {
  const label = (REPORT_TYPE_LABELS[type] || type || 'Report').replace(/\s+/g, '_')
  if (startDate && endDate) {
    return `UGEMS_Report_${label}_${startDate}_${endDate}.xlsx`
  }
  return `UGEMS_Report_${label}.xlsx`
}
